import React, { useEffect, useState } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import UsersTable from "./AdminMailingListUsersTable";
import MailTable from "./AdminMailingListMailTable";
import { Alert } from "reactstrap";
import { fetchWithToken } from "../../../../apiUtils";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  card: {
    marginTop: 40,
    marginBottom: 40,
  },
  title: {
    flex: "1 1 100%",
    margin: 40,
  },
  table: {
    marginTop: 45,
    marginBottom: 40,
  },
  loading: {
    marginTop: "25%",
    marginLeft: "50%",
  },
  submitButton: {
    margin: "15px",
    marginBottom: 40,
  },
  selectUserButton: {
    margin: "155px",
    marginBottom: 40,
  },
  checkbox: {
    width: "25px",
    height: "25px",
  },
  checkboxLabel: {
    fontSize: "20px",
    margin: "5px",
  },
  UserDesc: {
    fontSize: "20px",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

const AdminMailingList = (props) => {
  const classes = useStyles();
  var editable = !authObj.roles.includes("admin");

  const [dataObj, setDataObj] = useState({
    userData: [],
    mailList: [],
    loading: true,
  });

  // useEffect(() => {
  //   Promise.all([
  //     fetchWithToken("/api/UserPermissions/GetUserData"),
  //     fetchWithToken("/api/AdminMailingList"),
  //   ])
  //     .then(([res1, res2]) => Promise.all([res1.json(), res2.json()]))
  //     .then(([data1, data2]) => {
  //       setDataObj({
  //         userData: data1,
  //         mailList: data2,
  //         loading: false,
  //       });
  //     });
  // }, []);

  return (
    <>
      <div class="row">
        <div class="col-md-8 offset-md-2">
          {dataObj.loading ? (
            <CircularProgress className={classes.loading} />
          ) : (
            <>
              <Card className={classes.card}>
                <Typography
                  className={classes.title}
                  variant="h5"
                  id="tableTitle"
                  component="div"
                >
                  Admin Mailing List
                </Typography>
                <CardContent>
                  <MailTable
                    users={dataObj.userData}
                    mailList={dataObj.mailList}
                    setDataObj={setDataObj}
                  />
                  <div
                    class="d-flex justify-content-center"
                    style={{ marginTop: "50px" }}
                  >
                    <TransitionsModal
                      data={dataObj}
                      setDataObj={setDataObj}
                      editable={editable}
                    />
                  </div>
                </CardContent>
              </Card>
            </>
          )}
        </div>
      </div>
    </>
  );
};

const TransitionsModal = (props) => {
  const classes = useStyles();
  const { data, setDataObj, editable } = props;
  const [open, setOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState({
    message: "",
    active: false,
  });

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const sendAlert = (message, varient) => {
    setAlertMessage({
      message: message,
      varient: varient,
      active: true,
    });

    const timer = setTimeout(() => {
      setAlertMessage({
        message: "",
        varient: "",
        active: false,
      });
    }, 3500);
  };

  return (
    <>
      <Button
        type="button"
        onClick={handleOpen}
        variant="contained"
        color="primary"
        disabled={editable}
      >
        Select User
      </Button>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            {alertMessage.active && (
              <Alert color={alertMessage.varient}>{alertMessage.message}</Alert>
            )}

            {data.loading ? (
              <CircularProgress className={classes.loading} />
            ) : (
              <>
                <UsersTable
                  users={data.userData}
                  list={data.mailList}
                  setOpen={setOpen}
                  sendAlert={sendAlert}
                  setDataObj={setDataObj}
                />
              </>
            )}
          </div>
        </Fade>
      </Modal>
    </>
  );
};

export default AdminMailingList;
